export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/cloud-01.e9c66b45-e058cc.svg";